package com.exura

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.exura.chartsJS.initCharts
import com.exura.di.webModule
import com.exura.features.analytics.di.analyticsModule
import com.exura.features.demofeatures.di.demoFeaturesModule
import com.exura.features.demosets.di.demoSetsModule
import com.exura.features.di.commonModule
import com.exura.features.fileStorage.di.fileStorageModule
import com.exura.features.firebase.di.firebaseModule
import com.exura.features.legacyplans.di.legacyPlansModule
import com.exura.features.newauth.di.providerAuthModule
import com.exura.features.plandefinition.di.providerPlanDefinitionModule
import com.exura.features.publicplans.di.providerPublicPlansModule
import com.exura.features.userprofile.di.providerProfileModule
import com.exura.ui.FontFamily
import com.exura.ui.TextStyles
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.loadFromLocalStorage
import com.varabyte.kobweb.silk.theme.colors.saveToLocalStorage
import com.varabyte.kobweb.silk.theme.colors.systemPreference
import org.jetbrains.compose.web.css.Style
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.koin.core.context.startKoin

@InitSilk
fun setInitialColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.loadFromLocalStorage() ?: ColorMode.systemPreference
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    var initialized by remember { mutableStateOf(false) }
    Style(TextStyles)

    LaunchedEffect(Unit) {
        initCharts()
        FirebaseConfig.initialize()
        startKoin {
            modules(
                commonModule,
                webModule,

                firebaseModule,
                demoSetsModule,
                legacyPlansModule,
                providerAuthModule,
                providerPlanDefinitionModule,
                providerProfileModule,
                demoFeaturesModule,
                providerPublicPlansModule,
                fileStorageModule,
            )
        }
        initialized = true
    }

    if (initialized) {
        SilkApp {
            val colorMode = ColorMode.current
            LaunchedEffect(colorMode) {
                colorMode.saveToLocalStorage()
            }
            Surface(
                SmoothColorStyle
                    .toModifier()
                    .minHeight(100.vh)
                    .minWidth(100.vw)
                    .fontFamily(FontFamily.INTER),
            ) {
                content()
            }
        }
    }
}
